export default {
  isInitialized: false
};
